var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 34,
    viewBox: "0 0 20 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8333 2.83333V31.1667C19.8333 31.9181 19.5348 32.6388 19.0035 33.1701C18.4721 33.7015 17.7514 34 17 34H2.83333C2.08189 34 1.36122 33.7015 0.829863 33.1701C0.29851 32.6388 0 31.9181 0 31.1667V2.83333C0 2.08189 0.29851 1.36122 0.829863 0.829864C1.36122 0.298511 2.08189 0 2.83333 0H17C17.7514 0 18.4721 0.298511 19.0035 0.829864C19.5348 1.36122 19.8333 2.08189 19.8333 2.83333ZM17 31.1667V2.83333H2.83333V31.1667H17Z",
    fill: "#343330"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmall);
export default __webpack_public_path__ + "static/media/small.a8806224990b5415573cbf541943b1d1.svg";
export { ForwardRef as ReactComponent };